import { render, staticRenderFns } from "./ModalFrameForIndividualSettings.vue?vue&type=template&id=1402083c&scoped=true&lang=pug&"
import script from "./ModalFrameForIndividualSettings.vue?vue&type=script&lang=js&"
export * from "./ModalFrameForIndividualSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalFrameForIndividualSettings.vue?vue&type=style&index=0&id=1402083c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1402083c",
  null
  
)

export default component.exports